import axios from "axios";
import { getToken } from "../components/auth/authConfig";

const apiClient = axios.create();

apiClient.interceptors.request.use(
  async (config) => {
    const token = await getToken();

    config.headers = config.headers || {};
    config.headers["oidc-token"] = token;

    return config;
  },
  (error) => Promise.reject(error)
);

export const apiService = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  patch: (url, data, config) => apiClient.patch(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
};

export default apiClient;
